var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{ref:"input"}),_c('l-plate-picker',{model:{value:(_vm.plate),callback:function ($$v) {_vm.plate=$$v},expression:"plate"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }